import * as React from 'react'

function IconOpen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={49}
      height={49}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={24.5} cy={24.5} r={24.5} fill="#219321" />
      <path
        d="M35.337 21.267l-7.979 14.01c-1.248 2.191-4.368 2.191-5.617 0l-7.975-14.01c-1.249-2.195.313-4.933 2.81-4.933h15.955c2.497 0 4.055 2.738 2.806 4.933z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconOpen
